import { TZDate } from '@date-fns/tz';
import { format as formatFNS } from 'date-fns';

import { locales } from '../constants/locales';

export const formatDate = (
  dateInput: string | Date,
  pattern: string,
  options: {
    locale: keyof typeof locales;
    timeZone?: (value: string | number | Date) => TZDate;
    timeFormat?: 'TWELVE' | 'TWENTY_FOUR';
  } = {
    locale: 'en',
    timeZone: undefined,
    timeFormat: undefined,
  }
): string => {
  if (!dateInput) return '';
  const date = new Date(dateInput);
  if (isNaN(date.getTime())) return '';

  let finalPattern = pattern;

  if (options.timeFormat === 'TWELVE') {
    finalPattern = finalPattern.replace('HH:mm', 'h:mm aaa');
  }

  return formatFNS(date, finalPattern, {
    /*
      На `enUS` переключаемся только внутри английской локали: у `en` (en-GB) нет строчных
      am/pm. Раньше подмена шла для любого языка, и человек с 12-часовым форматом видел в
      русском интерфейсе «Сегодня, 9:53 pm», а в длинных шаблонах — ещё и «Monday, 31 August»
      посреди русского текста. У ru свой день-период: «9:53 дп» / «6:53 пп».
      Та же оговорка стоит в `formatDateRelative` и `formatDistanceToNow`.
    */
    locale:
      options.timeFormat === 'TWELVE' && options.locale === 'en'
        ? locales['enUS']
        : locales[options.locale],
    in: options.timeZone,
  });
};
